import { Decoder, iso8601, number, object } from "decoders";

export interface RainfallData {
  date: Date;
  rainfall: number;
}

export const rainfallDataDecoder: Decoder<RainfallData> = object({
  date: iso8601,
  rainfall: number,
});
